module.exports = __webpack_public_path__ + "static/media/fr.b1156355.svg";